import { useLocalStorage } from "usehooks-ts";

export const useSalesTableColumnWidths = () => {
  const [columnWidths, setColumnWidths] = useLocalStorage<
    Record<string, number>
  >("useSalesTableColumnWidths", {});

  return { columnWidths, setColumnWidths };
};
